export enum ConnectTypeUperEnum {
  HB_TYPE_ERROR = 0, // 0 = Nao Encontrado
  HB_TYPE_ASSESSOR = 1, // 1 = Assessor
  HB_TYPE_BROKER = 2, // 2 = Corretora
  HB_TYPE_OFFILINE = 3, // 3 = Não conectado
  HB_TYPE_CEDRO = 4, // 4 = Cedro (WF)
  HB_TYPE_SIMULATOR = 5, // 5 = Simulador (WF)
  HB_TYPE_MARKET_DATA = 6 // 6 = Market Data
}
